import DabangSurvey from "../../../../src/events/2022/09/dabang-survey/main";
import * as React from 'react';
export default {
  DabangSurvey,
  React
};